import BaseError from "./BaseError"
export default class CoordinatesOutOfBounds extends BaseError {
  constructor({ x, y, map, height, width }) {
    super(
      `${x},${y} is out of bounds of map '${map.name}' with width ${width} and height ${height}`,
      undefined
    )
    this.x       = x
    this.y       = y
    this.map     = map
    this.height  = height
    this.width   = width
  }
}
